module.exports = __webpack_public_path__ + "img/logo-blue.76cbbbd4.png";